import React from "react";
import TitleSkeleton from "./skeleton/TitleSkeleton";
import styles from "./Title.module.css";

function Title(props) {
  const { loading, title } = props;

  if (!title || loading) {
    return <TitleSkeleton />;
  }

  return <h2 className={styles.title}>{title}</h2>;
}
export default Title;
